<template>
  <div class="intangibleCommon-area">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Input v-model="formItem.key" clearable placeholder="输入名称..."></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>
          </FormItem>
          <FormItem>
            <Button @click="showModel()" type="success" class="f-r">添加</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table border :columns="columns1" ref="selection" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal
      v-model="showModalStatus"
      title="添加"
      @on-ok="createBrand('brandValidate')"
      :loading="loading"
    >
      <Form :model="brand" ref="brandValidate" :rules="brandValidate" action="javascript:void(0)">
        <FormItem label="选择上一级" label-position="top">
          <Cascader :data="cateList" v-model="selectCate" @on-change="cateSelect" change-on-select></Cascader>
        </FormItem>
        <FormItem label="名称" prop="areaname">
          <Input v-model="brand.areaname" placeholder="输入名称..."></Input>
        </FormItem>
        <FormItem label="城市代码" prop="provinceid">
          <Input v-model="brand.provinceid" placeholder="输入城市代码..."></Input>
        </FormItem>
        <FormItem label="纬度" prop="lat">
          <Input v-model="brand.lat" placeholder="输入纬度..."></Input>
        </FormItem>
        <FormItem label="经度" prop="lng">
          <Input v-model="brand.lng" placeholder="输入经度..."></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 修改的弹出 -->
    <Modal
      v-model="showEditInfoStatus"
      title="修改"
      @on-ok="updateBrand('brandValidate')"
      :loading="loading"
    >
      <Form :model="brand" ref="brandValidate" :rules="brandValidate" action="javascript:void(0)">
        <FormItem label="选择上一级" label-position="top">
          <Cascader :data="cateList" v-model="selectCate" @on-change="cateSelect" change-on-select></Cascader>
        </FormItem>
        <FormItem label="名称" prop="areaname">
          <Input v-model="brand.areaname" placeholder="输入名称..."></Input>
        </FormItem>
        <FormItem label="城市代码" prop="provinceid">
          <Input v-model="brand.provinceid" placeholder="输入城市代码..."></Input>
        </FormItem>
        <FormItem label="纬度" prop="lat">
          <Input v-model="brand.lat" placeholder="输入纬度..."></Input>
        </FormItem>
        <FormItem label="经度" prop="lng">
          <Input v-model="brand.lng" placeholder="输入经度..."></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "intangibleCommon-area",
  data() {
    return {
      loading: true,
      dataloading: true,
      formItem: {},
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      columns1: [
        {
          title: "Id",
          key: "id",
          width: 100,
          fixed: "left"
        },
        {
          title: "标题",
          key: "areaname",
          fixed: "left"
        },
        {
          title: "城市代码",
          key: "provinceid",
          fixed: "left"
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showEditInfo(params.row.id);
                    }
                  }
                },
                "修改"
              )
              //   h(
              //     "Button",
              //     {
              //       props: {
              //         type: "error",
              //         size: "small"
              //       },
              //       on: {
              //         click: () => {
              //           this.remove(params.row.id);
              //         }
              //       }
              //     },
              //     "删除"
              //   )
            ]);
          }
        }
      ],
      tablelist: [],
      cateList: [],
      selectCate: [],
      selectCateId: "",
      brand: {
        name: "",
        sort: 0
      },
      showModalStatus: false,
      showEditInfoStatus: false,
      brandValidate: {
        name: [{ required: true, message: "名称必须填写", trigger: "blur" }]
      }
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function() {
    // 取数据
    this.getTableList();
    this.getCate();
  },
  methods: {
    getTableList: function() {
      var self = this;
      this.$api.area
        .list({
          page: this.pages.page,
          size: this.pages.size
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            self.tablelist = res.result.list;
            self.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    // 获取分类getCate
    getCate: function() {
      this.$api.area.droplist().then(res => {
        if (res.code == 200) {
          var total = res.result;
          var arr = new Array();
          for (var i in total) {
            var di = {
              value: total[i].f_id,
              label: total[i].f_name,
              children: []
            };
            for (var j in total[i].childs) {
              di.children.push({
                value: total[i].childs[j].s_id,
                label: total[i].childs[j].s_name
              });
            }
            arr.push(di);
          }

          this.cateList = arr;
        }
      });
      return;
    },
    cateSelect: function(value, selectedData) {
      if (
        selectedData != "" &&
        selectedData != undefined &&
        selectedData != null
      ) {
        var end = selectedData[selectedData.length - 1];
        this.selectCateId = end.value;
      }
    },
    // 展开添加
    showModel() {
      this.$refs["brandValidate"].resetFields();
      this.brand = {};
      this.selectCate = [];
      this.showModalStatus = !this.showModalStatus;
    },
    // 添加
    createBrand(name) {
      if (this.selectCateId) {
        this.brand.parentid = this.selectCateId;
      }
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.area.create(this.brand).then(res => {
            if (res.code == 200) {
              this.showModalStatus = !this.showModalStatus;
              this.brand.name = "";
              this.getTableList();
            }
          });
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    //展开修改
    showEditInfo: function(index) {
      this.branid = index;
      this.$refs["brandValidate"].resetFields();
      this.showEditInfoStatus = !this.showEditInfoStatus;
      // 取信息
      this.$api.area.detail({ id: index }).then(res => {
        if (res.code == 200) {
          this.brand = res.result;
          var selectCate = [];
          for (let i = 0; i < this.cateList.length; i++) {
            const cate = this.cateList[i];
            if (cate.value == this.brand.parentid) {
              selectCate.push(cate.value);
              this.selectCateId = cate.value;
              break;
            } else {
              var success = false;
              for (let j = 0; j < cate.children.length; j++) {
                const subCate = cate.children[j];
                if (subCate.value == this.brand.parentid) {
                  selectCate.push(cate.value);
                  selectCate.push(subCate.value);
                  this.selectCateId = subCate.value;
                  success = true;
                  break;
                }
              }
              if (success) {
                break;
              }
            }
          }
          this.selectCate = selectCate;
          this.$Message.success(res.msg);
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 修改名称
    updateBrand: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.selectCateId) {
            this.brand.parentid = this.selectCateId;
          }

          this.brand.id = this.branid;
          this.$api.area.edit(this.brand).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.showEditInfoStatus = !this.showEditInfoStatus;
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showCreateStatus = !this.showCreateStatus;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        page: this.pages.page,
        size: this.pages.size,
        key: this.formItem.key
      };
      this.$api.area.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  }
};
</script>
